import { createTheme } from "@mui/material/styles";

export const lightCustomerTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#191919",
      light: "#FFFFFF",
      dark: "#191919",
      contrastText: "#B00119",
    },
    background: {
      default: "#FFFFFF",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#191919", // Dark
      secondary: "#666666", // Optional
    },
    grey: {
      500: "#BDBDBD", // Disabled
    },
  },
  typography: {
    fontFamily: '"Figtree", sans-serif',
    allVariants: {
      fontFamily: '"Figtree", sans-serif',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: '"Figtree", sans-serif',
          textTransform: "none",
          fontWeight: 600,
        },
        containedPrimary: {
          backgroundColor: "#D0021B",
          color: "#FFFFFF",
          "&:hover": {
            backgroundColor: "#B00119",
          },
          "&.Mui-disabled": {
            backgroundColor: "#E0E0E0",
            color: "#9E9E9E",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: '"Figtree", sans-serif',
          backgroundColor: "#FFFFFF",
          "& .MuiInputBase-root": {
            fontFamily: '"Figtree", sans-serif',
            backgroundColor: "#FFFFFF",
            color: "#191919",
          },
          "& .MuiInputLabel-root": {
            fontFamily: '"Figtree", sans-serif',
            color: "#191919",
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: '"Figtree", sans-serif',
          backgroundColor: "#FFFFFF",
          color: "#191919",
        },
      },
    },
  },
});
